export const primary_color = '#691392';
export const second_color = '#07098c'; // COR PRIMÁRIA AZUL (?)

// export const PURPLE = '#753a88';
// export const RED = '#cc2b5e';
// export const WHITE = '#FFF';
// export const BLACK = '#000';
// export const BLUE = '#00BFFF';
// export const GREEN = '#28E8AC';